export { default as getMessages } from './i18n-messages';
